import { render, staticRenderFns } from "./saleDetail.vue?vue&type=template&id=50bb4056&scoped=true&"
import script from "./saleDetail.vue?vue&type=script&lang=js&"
export * from "./saleDetail.vue?vue&type=script&lang=js&"
import style0 from "./saleDetail.vue?vue&type=style&index=0&id=50bb4056&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bb4056",
  null
  
)

export default component.exports